function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "BTN_Edit",
  transform: "translate(-87 -357)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "HG",
  width: 33,
  height: 31,
  transform: "translate(87 357)",
  fill: "#fff",
  opacity: 0
}), /*#__PURE__*/React.createElement("g", {
  id: "Rechteck_117",
  "data-name": "Rechteck 117",
  transform: "translate(111.33 357) rotate(45)",
  fill: "#fff",
  stroke: "#ffe666",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("rect", {
  width: 8.921,
  height: 27.399,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1.5,
  y: 1.5,
  width: 5.921,
  height: 24.399,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Polygon_11",
  "data-name": "Polygon 11",
  transform: "translate(93.308 387.638) rotate(-135)",
  fill: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 6.409247398376465 6.783397674560547 L 2.511331796646118 6.783397674560547 L 4.460289478302002 3.16389799118042 L 6.409247398376465 6.783397674560547 Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 4.460289478302002 1.109257698059082 C 4.806131839752197 1.109257698059082 5.151974678039551 1.284557819366455 5.34075927734375 1.635158061981201 L 8.126829147338867 6.809297561645508 C 8.485569000244141 7.475527763366699 8.003039360046387 8.283397674560547 7.246359348297119 8.283397674560547 L 1.674219608306885 8.283397674560547 C 0.9175395965576172 8.283397674560547 0.4350090026855469 7.475527763366699 0.7937498092651367 6.809297561645508 L 3.579819679260254 1.635158061981201 C 3.768604278564453 1.284557819366455 4.114447116851807 1.109257698059082 4.460289478302002 1.109257698059082 Z",
  stroke: "none",
  fill: "#ffe666"
})));

function SvgBtnEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 31,
    viewBox: "0 0 33 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnEdit);
export default __webpack_public_path__ + "static/media/BTN_Edit.570637b233eaae6ab733507b8fb762b0.svg";
export { ForwardRef as ReactComponent };